import { Controller } from "stimulus"

export default class extends Controller {
  connect() {
    this.beforeStreamRender = this.beforeStreamRender.bind(this)
    this.afterSubmitEnd = this.afterSubmitEnd.bind(this)
    this.observer = new MutationObserver(() => this.scrollToBottomSoon())
    this.observer.observe(this.element, { childList: true, subtree: true })
    document.addEventListener("turbo:before-stream-render", this.beforeStreamRender)
    document.addEventListener("turbo:submit-end", this.afterSubmitEnd)
    this.scrollToBottom()
  }

  disconnect() {
    this.observer?.disconnect()
    document.removeEventListener("turbo:before-stream-render", this.beforeStreamRender)
    document.removeEventListener("turbo:submit-end", this.afterSubmitEnd)
    cancelAnimationFrame(this.frame)
  }

  scrollToBottom() {
    this.element.scrollTop = this.element.scrollHeight
  }

  scrollToBottomSoon() {
    cancelAnimationFrame(this.frame)
    this.frame = requestAnimationFrame(() => this.scrollToBottom())
  }

  beforeStreamRender(event) {
    const stream = event.target
    const target = stream.getAttribute("target")

    if (target !== this.element.id && !this.element.querySelector(`#${target}`)) return

    const originalRender = event.detail.render
    event.detail.render = (currentElement) => {
      originalRender(currentElement)
      this.scrollToBottomSoon()
    }
  }

  afterSubmitEnd(event) {
    if (!event.detail.success) return
    if (!this.element.ownerDocument.contains(event.target)) return

    this.scrollToBottomSoon()
  }
}
